import moment from 'moment';

/**
 * Reihenfolge und Vorauswahl der Praktika eines Bewerbers.
 *
 * 🔴 Bewusst EIN Modul fuer beide Leser: Der Switcher zeigt die Reihenfolge an, der
 * Container entscheidet, wohin beim Oeffnen ohne Praktikum in der URL navigiert wird.
 * Laegen die Regeln doppelt vor, koennte das Dropdown ein anderes Praktikum
 * hervorheben als die Seite laedt -- und genau das faellt niemandem auf, weil beide
 * fuer sich richtig aussehen.
 *
 * Thomas 18.08.: "das juengste Praktikum muss quasi immer oben stehen, auf das Datum
 * bezogen." ⇒ Startdatum absteigend.
 */

// Strikt geparst: ein unerwartetes Format wird zu `null` statt zu einem Moment, dessen
// `valueOf()` NaN liefert -- NaN in einem Comparator ergibt eine willkuerliche Ordnung.
export const parseInternshipDate = (value) => {
  if (!value) return null;
  const date = moment(value, 'YYYY-MM-DD', true);
  return date.isValid() ? date : null;
};

// ⚠️ `starts_at` ist nullable (im Bestand am 18.08. lueckenlos gefuellt, 0 von 2341 leer).
// Ein Eintrag ohne Datum sortiert ans ENDE, statt die Ordnung zu sprengen.
export const compareByLatestStart = (a, b) => {
  const aStartsAt = parseInternshipDate(a.starts_at);
  const bStartsAt = parseInternshipDate(b.starts_at);
  if (!aStartsAt) return bStartsAt ? 1 : 0;
  if (!bStartsAt) return -1;
  return bStartsAt.valueOf() - aStartsAt.valueOf();
};

// Kopie statt Sortierung in-place: `internships` kommt aus dem Store, und ein
// mutierender Sort waere eine stille Fernwirkung auf jeden anderen Leser.
export const sortInternshipsByLatestStart = (internships) => (
  [...(internships || [])].sort(compareByLatestStart)
);

/** Das juengste Praktikum, oder `null` wenn es keines gibt. */
export const latestInternship = (internships) => (
  sortInternshipsByLatestStart(internships)[0] || null
);

// Keine leere Klammer und kein "Invalid Date", wenn ein Datum fehlt.
export const formatInternshipLabel = (internship) => {
  const startsAt = parseInternshipDate(internship.starts_at);
  const endsAt = parseInternshipDate(internship.ends_at);
  if (!startsAt || !endsAt) return internship.company_name;
  return `${internship.company_name} (${startsAt.format('DD.MM.YYYY')} – ${endsAt.format('DD.MM.YYYY')})`;
};
